// extracted by mini-css-extract-plugin
module.exports = {"onbehalfView":"OnbehalfView_onbehalfView__1BQII","title":"OnbehalfView_title__A1kNc","text":"OnbehalfView_text__2yK1p"};